// extracted by mini-css-extract-plugin
export default {"permission_denied_page":"permission-denied-page_permission_denied_page__l8qof","icon":"permission-denied-page_icon__QlW+v"};